import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import VRGalleryPage from './pages/VRGalleryPage';
import NavBar from './components/NavBar';
import { AuthProvider } from './contexts/AuthContext';
import { StateProvider } from './contexts/StateContext';

function App() {
  return (
    <AuthProvider>
      <StateProvider>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/vr" element={<VRGalleryPage />} />
        </Routes>
      </StateProvider>
    </AuthProvider>
  );
}

export default App;
